import { Accordion } from "react-bootstrap"

import * as Scrivito from "scrivito"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { TabWidget } from "./TabWidgetClass"

Scrivito.provideComponent(TabWidget, ({ widget }) => (
  <Accordion.Item eventKey={widget.id()}>
    <Accordion.Button className="accordion-button">
      <span className="accordion-button__title"> {widget.get("title")}</span>
      <Icon
        name={IconName.SMALL_CARET_UP}
        size={IconSize.XXS}
        className="accordion-button__indicator"
      />
    </Accordion.Button>
    <Accordion.Body>
      <Scrivito.ContentTag content={widget} attribute="content" />
    </Accordion.Body>
  </Accordion.Item>
))
